export default __webpack_public_path__ + "static/media/units-blue.99e4e08d.svg";